'use client';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';

import { ColorModeContext } from '../../contexts';
import { useColorMode } from '../../hooks';
import { getDesignTokens } from '../../utils';

import type { ColorModeContextState } from '../../contexts';
import type { PaletteOptions } from '@mui/material';
import type { FC, PropsWithChildren } from 'react';

export interface DarkModeProps {
  darkPalette: PaletteOptions;
}

/**
 * Dark Mode
 * implementation according to the mui documentation
 * @see https://mui.com/material-ui/customization/dark-mode/
 */
export const DarkModeController: FC<PropsWithChildren<DarkModeProps>> = ({
  children,
  darkPalette,
}) => {
  const { mode, colorMode, setMode } = useColorMode();

  const value: ColorModeContextState = useMemo(
    () => ({
      mode,
      setMode,
      colorMode,
      darkPalette,
    }),
    [mode, setMode, colorMode, darkPalette]
  );

  return (
    <ColorModeContext.Provider value={value}>
      <ThemeProvider
        theme={(defaultTheme) => createTheme( getDesignTokens( mode, defaultTheme, darkPalette ) )}
      >
        {children}
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};
